// extracted by mini-css-extract-plugin
export var actionButton = "_8n-1";
export var attachmentContainer = "_8n-2";
export var fileList = "_8n-4";
export var removeFileButton = "_8n-3";
export var richTextInput = "_8n-0";